// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.5 6C8.5 2.68629 11.1863 0 14.5 0H19V6H16C15.1716 6 14.5 6.67157 14.5 7.5V9H19.2808L17.7808 15H14.5V24H8.5V15H4.25V9H8.5V6Z"}}]};

const LogoFacebookFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-facebook-filled',
    ref,
    icon: element,
  },
));

LogoFacebookFilledIcon.displayName = 'LogoFacebookFilledIcon';

export default LogoFacebookFilledIcon;
